import { appConfig } from 'cd-eft/config/AppConfig';
import * as PRJ from 'cd-eft/_codegen_/openapi-generator/eft-prjadmin';
import axios from 'axios';
import { EftAuthAxiosInterceptor } from './EftAuthAxiosInterceptor';
import { UserIdentity } from 'cd-eft/security/UserIdentity';

const apiConfig = new PRJ.Configuration({ basePath: appConfig.endpoints.eftPrjAdminApiBasePath });

const axiosInstance = axios.create();
export const ProjectDetails = new PRJ.AddtionalProjectDetailsControllerApi(apiConfig, undefined, axiosInstance);
export const EftProjUserInputController = new PRJ.EftProjUserInputControllerApi(apiConfig, undefined, axiosInstance);
export const EftProjectAttachmentController = new PRJ.ProjectAttachmentControllerApi(
  apiConfig,
  undefined,
  axiosInstance
);
export const SpatialRefController = new PRJ.SpatialRefControllerApi(apiConfig, undefined, axiosInstance);
export const UserInputsController = new PRJ.UserInputsControllerApi(apiConfig, undefined, axiosInstance);
export const EftProjectController = new PRJ.EftProjectControllerApi(apiConfig, undefined, axiosInstance);
export const EftSessionController = new PRJ.EftSessionControllerApi(apiConfig, undefined, axiosInstance);
export const FfsController = new PRJ.FfsControllerApi(apiConfig, undefined, axiosInstance);
export const MessageController = new PRJ.MessageControllerApi(apiConfig, undefined, axiosInstance);
export const MetadataController = new PRJ.MetadataControllerApi(apiConfig, undefined, axiosInstance);
export const ProjectAttachmentController = new PRJ.ProjectAttachmentControllerApi(apiConfig, undefined, axiosInstance);
export const UserInfoController = new PRJ.UserInfoControllerApi(apiConfig, undefined, axiosInstance);
export const UserPreferenceController = new PRJ.UserPreferenceControllerApi(apiConfig, undefined, axiosInstance);
export const AdminGlobalPreferenceController = new PRJ.NetsPreferenceControllerApi(apiConfig, undefined, axiosInstance);
export const ValueDomainController = new PRJ.ValueDomainControllerApi(apiConfig, undefined, axiosInstance);
export const ProjectionMetadataController = new PRJ.ProjectionMetadataControllerApi(apiConfig, undefined, axiosInstance);
export const ProjectionMetadataCustomizedController = new PRJ.ProjectionMetadataCustomizedControllerApi(apiConfig, undefined, axiosInstance);
export const StateCountyController = new PRJ.StateCountyControllerApi(apiConfig, undefined, axiosInstance);
export const MetadataImageController = new PRJ.MetadataImageControllerApi(apiConfig, undefined, axiosInstance);
export const ReleaseNotesController = new PRJ.ReleaseNoteControllerApi(apiConfig, undefined, axiosInstance);
export const ProjectCommentController = new PRJ.ProjectCommentControllerApi(apiConfig, undefined, axiosInstance);
export const ProjectElementCommentController = new PRJ.ProjectElementCommentControllerApi(apiConfig, undefined, axiosInstance);
export const LatestNewsController = new PRJ.AnnouncementControllerApi(apiConfig, undefined, axiosInstance);
export const GlossaryController = new PRJ.GlossaryControllerApi(apiConfig, undefined, axiosInstance);
export const RoadmapController = new PRJ.RoadmapControllerApi(apiConfig, undefined, axiosInstance);
export const ParameterController = new PRJ.DefaultParameterControllerApi(apiConfig, undefined, axiosInstance);
export const LoggerControllerApi = new PRJ.LoggerControllerApi(apiConfig, undefined, axiosInstance);
export const SpatialRefControllerApi = new PRJ.SpatialRefControllerApi(apiConfig, undefined, axiosInstance);
export const AdminReportController = new PRJ.AdminReportControllerApi(apiConfig, undefined, axiosInstance);

export const ServiceStatusController = new PRJ.ServiceStatusControllerApi(apiConfig);
export const ProjectionTextController = new PRJ.EftProjectControllerApi(apiConfig, undefined, axiosInstance);

// create and activate the EftAuthAxiosInterceptor
const __eftAuthAxiosInterceptor = new EftAuthAxiosInterceptor(axiosInstance, UserIdentity);
__eftAuthAxiosInterceptor.activate();

// console.log('!!!! EFT-PROJ API INITIALIZED !!!!');
